<template>
  <div>
    <slot
      v-if="!toggleVisible"
      name="show"
      :show="show"
    >
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            absolute
            color="secondary"
            dark
            fab
            right
            top
            v-on="on"
            @click="show"
          >
            <v-icon>help</v-icon>
          </v-btn>
        </template>

        <span>Em caso de dúvidas, clique aqui</span>
      </v-tooltip>
    </slot>

    <v-dialog
      v-model="showDialog"
      max-width="85%"
      persistent
      @click:outside="close"
    >
      <component
        :is="tutorial"
        v-if="showDialog"
      />
    </v-dialog>
  </div>
</template>

<script>
import * as Tutoriais from '@/components/tutoriais';

export default {
  name: 'AppTutorial',

  components: {
    ...Tutoriais,
  },

  props: {
    tutorial: {
      type: String,
      required: true,
      default: '',
    },
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    toggleVisible: {
      type: Function,
      default: undefined,
    },
  },

  data() {
    return {
      dialog: false,
    };
  },

  computed: {
    showDialog: {
      get() {
        return this.hasTutorial && (this.dialogVisible || this.dialog);
      },
      set(value) {
        this.dialog = value;
      },
    },
    hasTutorial() {
      return Boolean(this.tutorial.trim());
    },
  },

  methods: {
    show(e) {
      this.dialog = true;
      e.stopPropagation();
    },
    close() {
      if (this.dialogVisible) {
        this.toggleVisible();
      }
      this.dialog = false;
    },
  },

  provide() {
    return {
      close: this.close,
    };
  },
};
</script>
